// eslint-disable-next-line no-restricted-imports
import { t } from '@lingui/macro'

const bannerText = t`
  This web application is provided as a tool for users to interact with the Best Dex Protocol on
  their own initiative, with no endorsement or recommendation of cryptocurrency trading activities. In doing so,
  BestDex is not recommending that users or potential users engage in cryptoasset trading activity, and users or
  potential users of the web application should not regard this webpage or its contents as involving any form of
  recommendation, invitation or inducement to deal in cryptoassets.
`

export default bannerText
